import React from 'react'

import { useLastSeenProducts } from '../../../hooks/lastSeenProducts/useLastSeenProducts'
import { ProductShelfBySkus } from '../../sections/ProductShelf/ProductShelfBySkus'

import type { ProductLayout } from '../../../types/Product'

export function LastSeenProducts({ layout }: { layout?: ProductLayout }) {
  const { hasSeeMore, isLoading, products } = useLastSeenProducts(4)

  const link = hasSeeMore ? '/o-que-te-interessou' : undefined

  return (
    <ProductShelfBySkus
      products={products}
      id="vitrine-ultimos-produtos-vistos"
      variant="horizontal"
      hasQuickView={false}
      backgroundColor="var(--color-grayScale-light)"
      loading={isLoading}
      title="O que te interessou"
      link={link}
      layout={layout}
      propsCarousel={{ arrow: {}, bullet: {} }}
      className="showcase-last-viewed-container"
    />
  )
}
